import React from "react";
import { Box, Typography } from "@mui/material";

type CanalOption = {
  value: any;
  label: string;
  color: string;
};

const canais: CanalOption[] = [
  { value: "1", label: "Ñ param.", color: "#BDBDBD" },
  { value: "2", label: "Verde", color: "#4CAF50" },
  { value: "3", label: "Amarelo", color: "#FFC107" },
  { value: "4", label: "Vermelho", color: "#F44336" },
  { value: "5", label: "Cinza", color: "#9E9E9E" },
  { value: "6", label: "Vistoria", color: "#3F51B5" },
];

interface CanalDisplayProps {
  value: any;
  title: string;
}

const CanalDisplay: React.FC<CanalDisplayProps> = ({ value, title }) => {
  const canal = canais.find((item) => item.value === value);

  return (
    <Box>
      <Typography
        variant="subtitle2"
        sx={{
          mb: 0.5,
          color: "#333",
          textAlign: "left",
        }}
      >
        {title}
      </Typography>
      <Box
        sx={{
          height: "36px",
          border: "1px solid rgba(0, 0, 0, 0.23)",
          borderRadius: "4px",
          display: "flex",
          alignItems: "center",
          px: 2,
        }}
      >
        {canal ? (
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <span
              style={{
                display: "inline-block",
                width: 12,
                height: 12,
                borderRadius: "50%",
                backgroundColor: canal.color,
              }}
            />
            <Typography sx={{ textAlign: "center" }}>{canal.label}</Typography>
          </Box>
        ) : (
          <Typography sx={{ color: "text.secondary", textAlign: "center" }}>
            Ñ definido
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default CanalDisplay;
